'use strict';

var jsxRuntime = require('react/jsx-runtime');

const SmallHeart = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx(jsxRuntime.Fragment, {
            children: jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.300049 5.08374C0.300049 2.90324 1.96838 1.04999 4.12862 1.04999C5.28408 1.04999 6.305 1.58806 7.00005 2.41907C7.6951 1.58806 8.71602 1.04999 9.87148 1.04999C12.0306 1.04999 13.7 2.89326 13.7 5.08374C13.7 5.16476 13.6861 5.24317 13.6603 5.31638C13.6497 5.53264 13.6229 5.75226 13.5752 5.971C13.5722 5.99618 13.5679 6.02121 13.5622 6.04596C13.4827 6.39078 13.3637 6.719 13.2044 7.02886C12.4529 8.76226 11.1936 10.1462 10.1486 11.0852C9.61995 11.5603 9.13653 11.93 8.78372 12.1821C8.6071 12.3082 8.4626 12.4053 8.36076 12.4718C8.30982 12.505 8.2695 12.5306 8.24112 12.5484L8.21269 12.5661C7.8696 12.7989 7.43924 12.95 6.98291 12.95C6.51915 12.95 6.09931 12.7943 5.75814 12.5692L5.72466 12.5484C5.69626 12.5306 5.65593 12.505 5.60498 12.4717C5.50311 12.4052 5.35859 12.3081 5.18194 12.1818C4.82908 11.9296 4.3456 11.5595 3.81685 11.0838C2.77181 10.1436 1.51263 8.75747 0.761299 7.0198C0.602076 6.71004 0.483099 6.38191 0.403648 6.03721C0.397078 6.0087 0.392306 5.97984 0.389352 5.95078C0.336378 5.68415 0.300049 5.3918 0.300049 5.08374Z",
                fill: "currentColor"
            })
        }) : jsxRuntime.jsx(jsxRuntime.Fragment, {
            children: jsxRuntime.jsx("path", {
                d: "M13 5.08375C13 3.2375 11.6029 1.75 9.87143 1.75C8.58571 1.75 7.48 2.58125 7 3.7625C6.52 2.58125 5.41429 1.75 4.12857 1.75C2.39714 1.75 1 3.24625 1 5.08375C1 5.355 1.03429 5.6175 1.08571 5.8625C1.08571 5.8625 1.08571 5.87125 1.08571 5.88C1.15429 6.1775 1.25714 6.4575 1.39429 6.72C2.78286 9.9575 6.13429 11.9787 6.13429 11.9787C6.38286 12.145 6.67429 12.25 6.98286 12.25C7.29143 12.25 7.59143 12.145 7.83143 11.9787C7.83143 11.9787 11.1829 9.9575 12.5714 6.72875C12.7086 6.46625 12.8114 6.18625 12.88 5.88875C12.88 5.88875 12.88 5.88 12.88 5.87125C12.94 5.6175 12.9657 5.355 12.9657 5.0925L13 5.08375Z",
                stroke: "currentColor",
                strokeWidth: "1.4",
                strokeLinejoin: "round"
            })
        })
    });
};

module.exports = SmallHeart;
